import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";
import CategoryPage from "./pages/CategoryPage";
import AboutPage from "./pages/AboutPage";
import CheckoutPage from "./pages/CheckoutPage";
import { BlogListPage, BlogPostPage } from "./pages/BlogPage";

// Admin
import AdminLogin from "./pages/admin/AdminLogin";
import { AdminLayout } from "./components/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { AdminProductList, AdminProductForm } from "./pages/admin/AdminProducts";
import { AdminBlogList, AdminBlogForm } from "./pages/admin/AdminBlog";
import AdminSettings from "./pages/admin/AdminSettings";

/**
 * Strips a trailing slash from the URL and redirects to the canonical path.
 * e.g. /admin/ → /admin
 */
function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();
  if (pathname !== '/' && pathname.endsWith('/')) {
    return <Navigate to={pathname.slice(0, -1) + search + hash} replace />;
  }
  return null;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <TrailingSlashRedirect />
      <ScrollToTop />
      <Routes>
        {/* Public store */}
        <Route path="/" element={<Index />} />
        <Route path="/hunting" element={<CategoryPage />} />
        <Route path="/fishing" element={<CategoryPage />} />
        <Route path="/archery" element={<CategoryPage />} />
        <Route path="/apparel" element={<CategoryPage />} />
        <Route path="/camping" element={<CategoryPage />} />
        <Route path="/accessories" element={<CategoryPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />

        {/* Blog */}
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProductList />} />
          <Route path="products/new" element={<AdminProductForm />} />
          <Route path="products/:id" element={<AdminProductForm />} />
          <Route path="blog" element={<AdminBlogList />} />
          <Route path="blog/new" element={<AdminBlogForm />} />
          <Route path="blog/:id" element={<AdminBlogForm />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
